import { Edit, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { calculateNextPackage } from "@/utils/kundenUtils";

// Hilfsfunktion: Farbklassen für Nächster Termin
function getTerminCell(naechster_termin) {
  if (!naechster_termin) return <span className="text-slate-400">–</span>;
  const now = new Date();
  const termin = new Date(naechster_termin);
  const diffMs = termin - now;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  const dateStr = termin.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit' });
  const timeStr = termin.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });

  if (diffDays < 0) {
    return (
      <span className="inline-flex items-center gap-1 text-red-600 font-medium">
        <span className="w-1.5 h-1.5 rounded-full bg-red-500 flex-shrink-0 inline-block" />
        {dateStr} {timeStr}
        <span className="text-xs font-normal">({Math.abs(diffDays)}d überfällig)</span>
      </span>
    );
  }
  if (diffDays === 0) {
    return (
      <span className="inline-flex items-center gap-1 text-blue-600 font-medium">
        <span className="w-1.5 h-1.5 rounded-full bg-blue-500 flex-shrink-0 inline-block" />
        Heute {timeStr}
      </span>
    );
  }
  if (diffDays <= 7) {
    return (
      <span className="inline-flex items-center gap-1 text-orange-600 font-medium">
        <span className="w-1.5 h-1.5 rounded-full bg-orange-400 flex-shrink-0 inline-block" />
        {dateStr} <span className="text-xs font-normal">(in {diffDays}d)</span>
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 text-emerald-700">
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 flex-shrink-0 inline-block" />
      {dateStr}
    </span>
  );
}

// Hilfsfunktion: Farbklassen für Zuletzt kontaktiert
function getZuletztCell(letzter_termin) {
  if (!letzter_termin) return <span className="text-slate-400">–</span>;
  const now = new Date();
  const termin = new Date(letzter_termin);
  const diffDays = Math.floor((now - termin) / (1000 * 60 * 60 * 24));
  const dateStr = termin.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit' });

  if (diffDays <= 7) {
    return (
      <span className="inline-flex items-center gap-1 text-emerald-700">
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 flex-shrink-0 inline-block" />
        {dateStr} <span className="text-xs font-normal">(vor {diffDays}d)</span>
      </span>
    );
  }
  if (diffDays <= 30) {
    return (
      <span className="inline-flex items-center gap-1 text-orange-600">
        <span className="w-1.5 h-1.5 rounded-full bg-orange-400 flex-shrink-0 inline-block" />
        {dateStr} <span className="text-xs font-normal">(vor {diffDays}d)</span>
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 text-red-600 font-medium">
      <span className="w-1.5 h-1.5 rounded-full bg-red-500 flex-shrink-0 inline-block" />
      {dateStr} <span className="text-xs font-normal">(vor {diffDays}d)</span>
    </span>
  );
}

// Tabellen-Ansicht für Kontakte
export default function TeampartnerTable({ data, onEdit, onDelete }) {
  return (
    <div className="bg-white rounded-xl shadow-md border border-slate-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full min-w-max">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">#</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Name</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Nächster Termin</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Nächstes Thema</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Zuletzt kontaktiert</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Typ</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Stufe</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Linie</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Thematik</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Produkte im Abo</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Produktempfehlung</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Veranstaltungen</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Actionpack</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Cellreset</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Nächstes Paket</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Follow-up</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Zu erledigen</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 whitespace-nowrap">Notizen</th>
              <th className="px-4 py-3 text-right text-sm font-semibold text-slate-700 whitespace-nowrap">Aktionen</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {data.map(tp => {
              const linieName = tp.linie && tp.linie !== "erstlinie" ? data.find(t => t.id === tp.linie)?.name : null;
              
              return (
                <tr key={tp.id} className="hover:bg-slate-50 transition-colors">
                  {/* # */}
                  <td className="px-4 py-3 text-sm font-bold text-slate-600 whitespace-nowrap">
                    {tp.displayNummer ? (tp.typ === "kaltkontakt" ? `#NK${tp.displayNummer}` : `#${tp.displayNummer}`) : "–"}
                  </td>
                  {/* Name */}
                  <td className="px-4 py-3 text-sm font-medium text-slate-800 whitespace-nowrap">{tp.name}</td>
                  {/* Nächster Termin – farbig */}
                  <td className="px-4 py-3 text-sm whitespace-nowrap">
                    {getTerminCell(tp.naechster_termin)}
                  </td>
                  {/* Nächstes Thema */}
                  <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap max-w-[160px]">
                    <div className="truncate">{tp.naechstes_thema || tp.thema || "–"}</div>
                  </td>
                  {/* Zuletzt kontaktiert – farbig */}
                  <td className="px-4 py-3 text-sm whitespace-nowrap">
                    {getZuletztCell(tp.letzter_termin || tp.zuletzt_kontaktiert)}
                  </td>
                  {/* Typ */}
                  <td className="px-4 py-3 text-sm whitespace-nowrap">
                    <span className={`px-2 py-1 text-xs rounded ${
                      tp.typ === "kaltkontakt" 
                        ? "bg-slate-100 text-slate-600"
                        : tp.typ === "kunde"
                        ? "bg-blue-100 text-blue-600"
                        : "bg-emerald-100 text-emerald-600"
                    }`}>
                      {tp.typ === "kaltkontakt" ? "NK" : tp.typ === "teampartner" ? "TP" : "Kunde"}
                    </span>
                  </td>
                  {/* Stufe */}
                  <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap">{tp.stufe || "–"}</td>
                  {/* Linie */}
                  <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap">
                    {tp.linie === "erstlinie" ? "Erstlinie" : linieName || "–"}
                  </td>
                  {/* Thematik */}
                  <td className="px-4 py-3 text-sm text-slate-600 max-w-xs">
                    {tp.thematik && tp.thematik.length > 0 ? (
                      <div className="flex flex-wrap gap-1">
                        {tp.thematik.slice(0, 2).map((thema, idx) => (
                          <span key={idx} className="px-1.5 py-0.5 bg-purple-100 text-purple-700 rounded text-xs whitespace-nowrap">
                            {thema}
                          </span>
                        ))}
                        {tp.thematik.length > 2 && <span className="text-xs text-slate-500">+{tp.thematik.length - 2}</span>}
                      </div>
                    ) : "–"}
                  </td>
                  {/* Produkte im Abo */}
                  <td className="px-4 py-3 text-sm text-slate-600 max-w-xs">
                    {tp.im_abo && tp.im_abo.length > 0 ? (
                      <div className="flex flex-wrap gap-1">
                        {tp.im_abo.slice(0, 2).map((prodId, idx) => {
                          if (prodId === "konzept-1") return <span key={idx} className="px-1.5 py-0.5 bg-green-100 text-green-700 rounded text-xs whitespace-nowrap">Konzept 1</span>;
                          const prod = data.find(p => p.id === prodId);
                          return prod ? <span key={idx} className="px-1.5 py-0.5 bg-green-100 text-green-700 rounded text-xs whitespace-nowrap">{prod.name}</span> : null;
                        })}
                        {tp.im_abo.length > 2 && <span className="text-xs text-slate-500">+{tp.im_abo.length - 2}</span>}
                      </div>
                    ) : "–"}
                  </td>
                  {/* Produktempfehlung */}
                  <td className="px-4 py-3 text-sm text-slate-600 max-w-xs">
                    {tp.produktempfehlung && tp.produktempfehlung.length > 0 ? (
                      <div className="flex flex-wrap gap-1">
                        {tp.produktempfehlung.slice(0, 2).map((prodId, idx) => {
                          if (prodId === "konzept-1") return <span key={idx} className="px-1.5 py-0.5 bg-yellow-100 text-yellow-700 rounded text-xs whitespace-nowrap">Konzept 1</span>;
                          const prod = data.find(p => p.id === prodId);
                          return prod ? <span key={idx} className="px-1.5 py-0.5 bg-yellow-100 text-yellow-700 rounded text-xs whitespace-nowrap">{prod.name}</span> : null;
                        })}
                        {tp.produktempfehlung.length > 2 && <span className="text-xs text-slate-500">+{tp.produktempfehlung.length - 2}</span>}
                      </div>
                    ) : "–"}
                  </td>
                  {/* Veranstaltungen */}
                  <td className="px-4 py-3 text-sm text-slate-600 max-w-xs">
                    {tp.online_live_veranstaltungen && tp.online_live_veranstaltungen.length > 0 ? (
                      <div className="flex flex-wrap gap-1">
                        {tp.online_live_veranstaltungen.slice(0, 2).map((v, idx) => (
                          <span key={idx} className="px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded text-xs whitespace-nowrap">{v}</span>
                        ))}
                        {tp.online_live_veranstaltungen.length > 2 && <span className="text-xs text-slate-500">+{tp.online_live_veranstaltungen.length - 2}</span>}
                      </div>
                    ) : "–"}
                  </td>
                  {/* Actionpack */}
                  <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap">
                    {tp.actionpack === "ja" ? "✅ Ja" : tp.actionpack === "interesse" ? "💡 Interesse" : tp.actionpack === "nein" ? "❌ Nein" : "–"}
                  </td>
                  {/* Cellreset */}
                  <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap">
                    {tp.cellreset_gemacht === "ja" ? "✅ Ja" : tp.cellreset_gemacht === "nicht_beendet" ? "⏳ Nicht beeendet" : tp.cellreset_gemacht === "nein" ? "❌ Nein" : "–"}
                  </td>
                  {/* Nächstes Paket */}
                  <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap">
                    {tp.befoerderungs_datum && tp.typ === "teampartner" ? (() => {
                      const { daysLeft } = calculateNextPackage(tp.befoerderungs_datum);
                      if (tp.paket_erinnerung_erledigt) return "✅ Erledigt";
                      return daysLeft <= 7
                        ? <span className="text-orange-600 font-medium">in {daysLeft}d</span>
                        : <span className="text-slate-600">in {daysLeft}d</span>;
                    })() : "–"}
                  </td>
                  {/* Follow-up */}
                  <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap">
                    {tp.befoerderungs_datum && tp.typ === "teampartner" ? (() => {
                      const done = [
                        tp.einnahmegespraech_erledigt,
                        tp.followup_3_5_erledigt,
                        tp.followup_14_erledigt,
                        tp.followup_30_erledigt,
                        tp.followup_28_erledigt,
                      ].filter(Boolean).length;
                      return `${done}/5 ✅`;
                    })() : "–"}
                  </td>
                  {/* Zu erledigen */}
                  <td className="px-4 py-3 text-sm text-slate-600 max-w-xs">
                    <div className="truncate">
                      {(() => {
                        const tasks = Array.isArray(tp.noch_zu_erledigen) ? tp.noch_zu_erledigen : (tp.noch_zu_erledigen ? [{ text: tp.noch_zu_erledigen }] : []);
                        if (!tasks.length) return '–';
                        const open = tasks.filter(t => !t.done).length;
                        return `${open}/${tasks.length} offen`;
                      })()}
                    </div>
                  </td>
                  {/* Notizen */}
                  <td className="px-4 py-3 text-sm text-slate-600 max-w-xs">
                    <div className="truncate">{tp.notizen || "–"}</div>
                  </td>
                  {/* Aktionen */}
                  <td className="px-4 py-3 text-sm text-right whitespace-nowrap">
                    <div className="flex gap-2 justify-end">
                      <Button size="sm" variant="outline" onClick={() => onEdit(tp)}>
                        <Edit className="w-3 h-3" />
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => onDelete(tp.id)} className="text-red-600 hover:text-red-700">
                        <Trash2 className="w-3 h-3" />
                      </Button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
